import apiClient from "./apiClient";

// LOGIN API
export const login = async (payload) => {
    try {
        const response = await apiClient.post("/login", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// CHANGE PASSWORD
export const changePassword = async (payload) => {
    try {
        const response = await apiClient.post("/change_pass", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// FORGOT PASSWORD
export const forgotPassword = async (payload) => {
    try {
        const response = await apiClient.post(
            "/send_reset_password_link",
            payload
        );

        return response.data;

    } catch (error) {
        throw error.response?.data || error.message;
    }
};
